// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KVysleWeYmMuEvtH {
  max-width: 1200px;
  margin: 0 auto;
}
.DGJrDYjNdBghdSfU {
  margin: 24px 0 22px 0;
  font-size: 14px;
  color: #333;
  cursor: pointer;
}
.ZdskJiIbUTa8OjX7 {
  width: 1056px;
  margin: 0 auto;
}
.CX4UuxlJvU0oZm0K {
  display: flex;
  justify-content: center;
  align-items: center;
}
.dEXuxcDGPUdOhno9 {
  background: url(https://p5.ssl.qhimg.com/t011ec52c575edc6084.png);
  background-position: center;
  width: 64px;
  height: 64px;
  margin-right: 16px;
  background-size: cover;
}
.cGfZp_9XKec6uBvc {
  background: #ffffff;
  width: 1056px;
  border-radius: 8px;
  margin-top: 16px;
  padding: 32px 33px 30px;
  line-height: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.cWRJvgI9kfIBep3d {
  flex: 1 0 50%;
  display: flex;
  margin-bottom: 44px;
}
.GRdBq70O02U6J6P3 {
  color: #666666;
  font-size: 14px;
  width: 120px;
  text-align: right;
  margin-right: 16px;
}
.ofz3LjR5_tkbVv9T {
  width: 400px;
}
.BVOmMAlbbQeJeUqQ {
  color: #333333;
  font-size: 14px;
  font-weight: bold;
}
.BVOmMAlbbQeJeUqQ span {
  display: inline-block;
  vertical-align: middle;
}
.uHiJx09VBA_AIClE {
  margin: 0 auto;
  width: auto;
  display: flex;
  justify-content: center;
  user-select: none;
  margin-top: 64px;
}
.uHiJx09VBA_AIClE > div {
  width: 128px;
  height: 48px;
  border-radius: 8px;
  opacity: 1;
  line-height: 48px;
  text-align: center;
  cursor: pointer;
}
.Qd5AGI2Ew4e1s_PF {
  background: #ffffff;
  color: #666666;
  font-size: 16px;
  font-weight: bold;
  margin-right: 16px;
}
.Qr92uPNNGYaojqhv {
  background: #0095fc;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
}
.BfW6Pme2SrA_Zjma {
  display: inline-block;
  vertical-align: middle;
  margin-right: 11px;
}
.xEm3WN14I7sfcQBj {
  vertical-align: middle;
  color: #666;
  width: 20px;
  cursor: pointer;
}
.xEm3WN14I7sfcQBj:hover {
  color: #0095fc;
}
.xEm3WN14I7sfcQBj:active {
  color: #0095fc;
}
.UB8vDg1zhIi61dg9 {
  color: #0095fc;
}
.kHm8fns04_8ylJdC {
  border-radius: 100px;
  opacity: 1;
  border: 1px dashed #dbdbdb;
  color: #dbdbdb;
  background: #fff;
}
.BHXMoSoj0oMKitW9 {
  width: 320px;
  height: 40px;
  border-radius: 8px;
  opacity: 1;
  background: #e7edf4;
  border: 0;
  outline: none;
  box-sizing: border-box;
  padding: 0 12px;
}
.aKWLcdsW0gt6rQSV {
  width: 24px;
  margin-left: 13px;
  vertical-align: middle;
}
`, "",{"version":3,"sources":["webpack://./app/assets/pages/detail/index.module.less"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,cAAA;AACF;AACA;EACE,qBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;AACF;AACA;EACE,aAAA;EACA,cAAA;AACF;AACA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;AACA;EACE,iEAAA;EACA,2BAAA;EAEA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AAAF;AAEA;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;AAAF;AAEA;EACE,aAAA;EACA,aAAA;EACA,mBAAA;AAAF;AAEA;EACE,cAAA;EACA,eAAA;EAEA,YAAA;EACA,iBAAA;EACA,kBAAA;AADF;AAGA;EACE,YAAA;AADF;AAGA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;AADF;AAFA;EAKI,qBAAA;EACA,sBAAA;AAAJ;AAGA;EACE,cAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;AADF;AALA;EAQI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AAAJ;AAGA;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AADF;AAGA;EACE,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;AADF;AAGA;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;AADF;AAGA;EACE,sBAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;AADF;AAEE;EACE,cAAA;AAAJ;AAEE;EACE,cAAA;AAAJ;AAGA;EACE,cAAA;AADF;AAGA;EACE,oBAAA;EACA,UAAA;EACA,0BAAA;EACA,cAAA;EACA,gBAAA;AADF;AAGA;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EAEA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;AAFF;AAIA;EACE,WAAA;EACA,iBAAA;EACA,sBAAA;AAFF","sourcesContent":[".detail {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n.back {\n  margin: 24px 0 22px 0;\n  font-size: 14px;\n  color: #333;\n  cursor: pointer;\n}\n.detailwrapper {\n  width: 1056px;\n  margin: 0 auto;\n}\n.detailTop {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.logo {\n  background: url(https://p5.ssl.qhimg.com/t011ec52c575edc6084.png);\n  background-position: center;\n  background-size: cover;\n  width: 64px;\n  height: 64px;\n  margin-right: 16px;\n  background-size: cover;\n}\n.detailContent {\n  background: #ffffff;\n  width: 1056px;\n  border-radius: 8px;\n  margin-top: 16px;\n  padding: 32px 33px 30px;\n  line-height: 20px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n.detailItem {\n  flex: 1 0 50%;\n  display: flex;\n  margin-bottom: 44px;\n}\n.itemName {\n  color: #666666;\n  font-size: 14px;\n  // width: 82px;\n  width: 120px;\n  text-align: right;\n  margin-right: 16px;\n}\n.textAreaStyle{\n  width: 400px;\n}\n.itemVal {\n  color: #333333;\n  font-size: 14px;\n  font-weight: bold;\n  span {\n    display: inline-block;\n    vertical-align: middle;\n  }\n}\n.deleteGroup {\n  margin: 0 auto;\n  width: auto;\n  display: flex;\n  justify-content: center;\n  user-select: none;\n  margin-top: 64px;\n  > div {\n    width: 128px;\n    height: 48px;\n    border-radius: 8px;\n    opacity: 1;\n    line-height: 48px;\n    text-align: center;\n    cursor: pointer;\n  }\n}\n.delete {\n  background: #ffffff;\n  color: #666666;\n  font-size: 16px;\n  font-weight: bold;\n  margin-right: 16px;\n}\n.onShelves {\n  background: #0095fc;\n  font-size: 16px;\n  font-weight: bold;\n  color: #fff;\n}\n.copytext {\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 11px;\n}\n.copy {\n  vertical-align: middle;\n  color: #666;\n  width: 20px;\n  cursor: pointer;\n  &:hover {\n    color: #0095fc;\n  }\n  &:active {\n    color: #0095fc;\n  }\n}\n.copiedAppid {\n  color: #0095fc;\n}\n.disabled {\n  border-radius: 100px;\n  opacity: 1;\n  border: 1px dashed #dbdbdb;\n  color: #dbdbdb;\n  background: #fff;\n}\n.editInput {\n  width: 320px;\n  height: 40px;\n  border-radius: 8px;\n  opacity: 1;\n\n  background: #e7edf4;\n  border: 0;\n  outline: none;\n  box-sizing: border-box;\n  padding: 0 12px;\n}\n.editor {\n  width: 24px;\n  margin-left: 13px;\n  vertical-align: middle;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"detail": `KVysleWeYmMuEvtH`,
	"back": `DGJrDYjNdBghdSfU`,
	"detailwrapper": `ZdskJiIbUTa8OjX7`,
	"detailTop": `CX4UuxlJvU0oZm0K`,
	"logo": `dEXuxcDGPUdOhno9`,
	"detailContent": `cGfZp_9XKec6uBvc`,
	"detailItem": `cWRJvgI9kfIBep3d`,
	"itemName": `GRdBq70O02U6J6P3`,
	"textAreaStyle": `ofz3LjR5_tkbVv9T`,
	"itemVal": `BVOmMAlbbQeJeUqQ`,
	"deleteGroup": `uHiJx09VBA_AIClE`,
	"delete": `Qd5AGI2Ew4e1s_PF`,
	"onShelves": `Qr92uPNNGYaojqhv`,
	"copytext": `BfW6Pme2SrA_Zjma`,
	"copy": `xEm3WN14I7sfcQBj`,
	"copiedAppid": `UB8vDg1zhIi61dg9`,
	"disabled": `kHm8fns04_8ylJdC`,
	"editInput": `BHXMoSoj0oMKitW9`,
	"editor": `aKWLcdsW0gt6rQSV`
};
export default ___CSS_LOADER_EXPORT___;
